<script>
import vue2Dropzone from "vue2-dropzone";
import Multiselect from "vue-multiselect";
import { settingService } from "../../../services";
import { required } from "vuelidate/lib/validators";
import { numeric } from "vuelidate/lib/validators";
import { error_message, success_message } from "../../../Helper/helper";
import config from "../../../config";

/**
 * Starter component
 */
export default {
  components: { vueDropzone: vue2Dropzone, Multiselect },
  data() {
    return {
      config: config,
      checked: true,
      value: null,
      order_assign_class: "switch-on",
      setting: [],
      delivery_charges: [
        { id: "Order Amount", text: "Amount", show: "Value" },
        //{ id: "Delivery Distance (Km)", text: "Distance", show: "Distance" },
      ],
      deliverycharges: [{ min_value: "", max_value: "", delivery_charges: "" }],
      businessdeliverycharges: [{ min_value: "", max_value: "", delivery_charges: "" }],
      errors: "",
      setting: {
        order_commission: "",
        order_auto_refresh: "",
        is_order_assigned_manually: "",
        is_enable_live_tracking_app: 0,
        vendor_max_time: "",
        driver_max_time: "",
        charge: [],
        order_dashboard_default_time: "0",
        order_notification_sound: "notification.mp3",
      },
      default_time_options: config.default_time_options,
      default_notification_sounds: config.default_notification_sounds,
      playing: false,
      sound: null,
    };
  },
  validations: {
    setting: {
      order_commission: {
        required,
        numeric,
      },
      order_auto_refresh: {
        required,
        numeric,
      },
      vendor_max_time: {
        required,
        numeric,
      },
      order_notification_sound: {
        required,
      },
      driver_max_time: {
        required,
        numeric,
      },
      charges: {
        $each: {
          min_value: {
            required,
          },
        },
      },
    },
    deliverycharges: {
      $each: {
        min_value: {
          required,
        },
      },
    },
    businessdeliverycharges: {
      $each: {
        min_value: {
          required,
        },
      },
    },
  },
  mounted() {
    this.getSetting();
    this.value = this.delivery_charges.find((d) => d.text == "Amount");
  },
  methods: {
    AddField: function () {
      this.deliverycharges.push({
        min_value: "",
        max_value: "",
        delivery_charges: "",
      });
    },
    AddBusinessField: function () {
      this.businessdeliverycharges.push({
        min_value: "",
        max_value: "",
        delivery_charges: "",
      });
    },
    getSetting() {
      settingService.getSetting().then((response) => {
        this.setting = response.data.result;
        this.value = this.delivery_charges.find(
          (d) => d.text == response.data.result.delivery_charges_type
        ) || this.delivery_charges.find((d) => d.text == "Amount");
        // Ensure charges are properly formatted with min_value, max_value, and delivery_charges
        if (response.data.result.delivery_charges_private && Array.isArray(response.data.result.delivery_charges_private) && response.data.result.delivery_charges_private.length > 0) {
          this.deliverycharges = response.data.result.delivery_charges_private.map(charge => ({
            min_value: charge.min_value || "",
            max_value: charge.max_value || "",
            delivery_charges: charge.delivery_charges || ""
          }));
        } else {
          this.deliverycharges = [{ min_value: "", max_value: "", delivery_charges: "" }];
        }
        console.log(this.deliverycharges,response.data.result.delivery_charges_business,'rinka');
        // Ensure business charges are properly formatted with min_value, max_value, and delivery_charges
        if (response.data.result.delivery_charges_business && Array.isArray(response.data.result.delivery_charges_business) && response.data.result.delivery_charges_business.length > 0) {
          this.businessdeliverycharges = response.data.result.delivery_charges_business.map(charge => ({
            min_value: charge.min_value || "",
            max_value: charge.max_value || "",
            delivery_charges: charge.delivery_charges || ""
          }));
        } else {
          this.businessdeliverycharges = [{ min_value: "", max_value: "", delivery_charges: "" }];
        }
      });
    },
    is_order_assigned($event) {
      this.setting[$event.target.name] = $event.target.checked ? "Yes" : "No";
    },
    orderInIt() {
      this.$v.$touch();
      if (this.$v.setting.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("order_commission", this.setting.order_commission);
        fd.append("order_auto_refresh", this.setting.order_auto_refresh);
        fd.append("vendor_max_time", this.setting.vendor_max_time);
        fd.append("driver_max_time", this.setting.driver_max_time);
        fd.append("delivery_charges_type", this.value ? this.value.text : "Amount");
        fd.append(
          "is_order_assigned_manually",
          this.setting.is_order_assigned_manually
        );
        fd.append(
          "is_enable_live_tracking_app",
          this.setting.is_enable_live_tracking_app
        );
        // Ensure delivery charges are properly formatted as JSON with min_value, max_value, and delivery_charges
        const formattedPrivateCharges = this.deliverycharges.map(charge => ({
          min_value: charge.min_value || "",
          max_value: charge.max_value || "",
          delivery_charges: charge.delivery_charges || ""
        }));
        fd.append("deliverycharges", JSON.stringify(formattedPrivateCharges));
        
        // Ensure business delivery charges are properly formatted as JSON with min_value, max_value, and delivery_charges
        const formattedBusinessCharges = this.businessdeliverycharges.map(charge => ({
          min_value: charge.min_value || "",
          max_value: charge.max_value || "",
          delivery_charges: charge.delivery_charges || ""
        }));
        fd.append("businessdeliverycharges", JSON.stringify(formattedBusinessCharges));
        fd.append(
          "order_dashboard_default_time",
          this.setting.order_dashboard_default_time
        );
        fd.append(
          "order_notification_sound",
          this.setting.order_notification_sound
        );
        fd.append("type", 2);
        settingService.updateSetting(fd).then((response) => {
          if (response.data.code === 200) {
            if (response.data.result) {
              this.$auth.updateSetting(response.data.result.settings);
            }
            success_message(response.data.message);
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
    remove_delivery_charges(index) {
      this.deliverycharges.splice(index, 1);
    },
    remove_business_delivery_charges(index) {
      this.businessdeliverycharges.splice(index, 1);
    },
    playSound() {
      if (!this.playing) {
        this.sound = new Audio(
          this.config.appurl + this.setting.order_notification_sound
        );
        this.sound.play();
        this.playing = true;
      } else {
        this.sound.pause();
        this.sound.currentTime = 0;
        this.playing = false;
      }
    },
  },
};
</script>
<template>
  <b-form @submit.prevent="orderInIt">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body setting-main">
            <div class="row section-main">
              <div class="col-md-4">
                <div class="setting-heading">
                  <h4>{{ trans.get("__JSON__.Basic Settings") }}</h4>
                </div>
              </div>
              <div class="col-md-8">
                <div class="setting-data">
                  
                  <div class="row mt-4">
                    <div class="col-md-12">
                      <h6>
                        {{ trans.get("__JSON__.Is Order Assigned Manually") }}
                      </h6>
                    </div>
                    <div class="col-md-6 order-value">
                      <div class="swtich-data">
                       
                        <b-form-group>
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="is_order_assigned_manually"
                              name="is_order_assigned_manually"
                              v-model="setting.is_order_assigned_manually"
                              class="switch-on"
                              true-value="Yes"
                              false-value="No"
                            />
                            <div class="slider round">
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                            </div>
                          </label>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <p>
                        {{
                          trans.get(
                            "__JSON__.By Enabling this Option orders will be assign to Delivery Boys automatically"
                          )
                        }}.
                      </p>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-md-12">
                      <h6>
                        {{ trans.get("__JSON__.Live Tracking Enabled in App") }}
                      </h6>
                    </div>
                    <div class="col-md-6 order-value">
                      <div class="swtich-data">
                        <b-form-group>
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="is_enable_live_tracking_app"
                              name="is_enable_live_tracking_app"
                              v-model="setting.is_enable_live_tracking_app"
                              class="switch-on"
                              true-value="1"
                              false-value="0"
                            />
                            <div class="slider round">
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                            </div>
                          </label>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <p>
                        {{
                          trans.get(
                            "__JSON__.By Enabling this Option customer will able to live track orders on Google map"
                          )
                        }}.
                      </p>
                    </div>
                  </div>

                  
                  <div class="row mt-4">
                    <div class="col-md-6 order-value">
                      <b-form-group
                        id="input-group-1"
                        :label="
                          trans.get('__JSON__.Order Dashboard Default Date')
                        "
                        label-for="name"
                      >
                        <b-form-select
                          v-model="setting.order_dashboard_default_time"
                          :options="default_time_options"
                        ></b-form-select>
                        <div
                          v-if="$v.setting.driver_max_time.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.setting.driver_max_time.required"
                            >{{
                              trans.trans(
                                "__JSON__.Autocancel Order For Driver (In Seconds)",
                                { driver: $auth.setting.driver_name }
                              )
                            }}.</span
                          >
                          <span v-if="!$v.setting.driver_max_time.numeric"
                            >{{
                              trans.get("__JSON__.Enter Numeric Value")
                            }}.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-12">
                      <p>
                        {{
                          trans.get(
                            "__JSON__.Set the default date range for the Ordering Dashboard page"
                          )
                        }}.
                      </p>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-md-6 order-value">
                      <b-form-group
                        id="input-group-1"
                        :label="trans.get('__JSON__.Order Notification Sound')"
                        label-for="name"
                      >
                        <b-form-select
                          v-model="setting.order_notification_sound"
                          :options="default_notification_sounds"
                        ></b-form-select>
                      </b-form-group>
                      <div
                        v-if="$v.setting.order_notification_sound.$error"
                        class="invalid-feedback"
                      >
                        <span
                          v-if="!$v.setting.order_notification_sound.required"
                        >
                          {{
                            trans.get(
                              "__JSON__.Please select notification sound"
                            )
                          }}.
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6 order-value">
                      <b-button
                        variant="link"
                        @click="playSound()"
                        class="top-26"
                        ><i
                          class="fas"
                          :class="{ 'fa-play': !playing, 'fa-stop': playing }"
                        ></i
                      ></b-button>
                    </div>
                    <div class="col-md-12">
                      <p>
                        {{ trans.get("__JSON__.New order notification sound") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row section-main">
              <div class="col-md-4">
                <div class="setting-heading">
                  <h4>Delivery Charges For Private</h4>
                </div>
              </div>
              <div class="col-md-8">
                <div class="setting-data">
                  <div class="row">
                    <div class="col-md-12">
                      <h6>Delivery Charge Based On Amount</h6>
                    </div>
                    <!-- <div class="col-md-6 order-value">
                      <multiselect
                        v-model="value"
                        :options="delivery_charges"
                        track-by="id"
                        label="id"
                        value="text"
                        name="delivery_charges"
                        placeholder="Select one"
                        id="delivery_charges"
                        :searchable="false"
                        :allow-empty="false"
                      ></multiselect>
                    </div>
                    <div class="col-md-12">
                      <p>
                        Select How you wish to set Delivery Charge to Customer.
                      </p>
                    </div> -->
                  </div>
                  <div class="row mt-3">
                    <div
                      class="col-md-12"
                      v-for="(v, index) in deliverycharges"
                      :key="index"
                    >
                      <div class="row mt-2">
                        <div class="col-md-3">
                          <h6>Order {{ value && value.show }} From</h6>
                          <input
                            v-model="v.min_value"
                            name="min_value[]"
                            type="number"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-3">
                          <h6>Order {{ value && value.show }} To</h6>
                          <input
                            v-model="v.max_value"
                            name="max_value[]"
                            type="number"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-3">
                          <h6>Charges</h6>
                          <input
                            v-model="v.delivery_charges"
                            name="delivery_charges[]"
                            type="number"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-3">
                          <h6>&nbsp;</h6>
                          <button
                            class="btn btn-primary btn-sm btn-rounded"
                            @click.prevent="AddField"
                          >
                            +</button
                          >&nbsp;&nbsp;
                          <button
                            class="btn btn-danger btn-sm btn-rounded"
                            v-if="index != 0 || index != ''"
                            @click.prevent="remove_delivery_charges(index)"
                          >
                            -
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row section-main">
              <div class="col-md-4">
                <div class="setting-heading">
                  <h4>Delivery Charges For Business</h4>
                </div>
              </div>
              <div class="col-md-8">
                <div class="setting-data">
                  <div class="row">
                    <div class="col-md-12">
                      <h6>Delivery Charge Based On Amount</h6>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div
                      class="col-md-12"
                      v-for="(v, index) in businessdeliverycharges"
                      :key="index"
                    >
                      <div class="row mt-2">
                        <div class="col-md-3">
                          <h6>Order {{ value && value.show }} From</h6>
                          <input
                            v-model="v.min_value"
                            name="business_min_value[]"
                            type="number"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-3">
                          <h6>Order {{ value && value.show }} To</h6>
                          <input
                            v-model="v.max_value"
                            name="business_max_value[]"
                            type="number"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-3">
                          <h6>Charges</h6>
                          <input
                            v-model="v.delivery_charges"
                            name="business_delivery_charges[]"
                            type="number"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-3">
                          <h6>&nbsp;</h6>
                          <button
                            class="btn btn-primary btn-sm btn-rounded"
                            @click.prevent="AddBusinessField"
                          >
                            +</button
                          >&nbsp;&nbsp;
                          <button
                            class="btn btn-danger btn-sm btn-rounded"
                            v-if="index != 0 || index != ''"
                            @click.prevent="remove_business_delivery_charges(index)"
                          >
                            -
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="btn-update">
              <div class="col-sm-6">
                <button
                  type="submit"
                  v-if="
                    $auth.hasPermission(config.permissions.configuration_write)
                  "
                  class="btn btn-primary mr-1 mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>
<style scoped>
.top-26 {
  margin-top: 26px;
}
</style>